export default __webpack_public_path__ + "static/media/2a6dae53616869.593a85ce553c4.d97b1772.gif";